<template>
  <header class="container-header">
    <img class="honey-bee-1" src="../../public/image/honeyBee.png">
    <img class="honey-bee-2" src="../../public/image/honeyBee.png">
    <transition mode="out-in">
      <div class="header-first header" v-if="showheader">
        <div class="header-first__box header__box">
          <h1>عسل طبیعی و ارگانیک نیش و نوش</h1>
          <p>
            خواص دارویی و درمانی عسل برتر از تمامیه غذا ها و داروها است
          </p>
          <router-link class="base-btn-1" to="/product"
            >همین حالا سفارش بده</router-link
          >
        </div>
      </div>

      <div class="header-secound header" v-else>
        <div class="header-secound__box header__box">
          <h1 >فروش مرغوب ترین انواع عسل به شرط آزمایش</h1>
          <p>
            با مصرف عسل طبیعی جسمتان را دربرابر امراض مختلف ایمن کنید
          </p>
          <router-link class="base-btn-1" to="/product"
            >همین حالا سفارش بده</router-link
          >
        </div>
      </div>
    </transition>
    <div class="change-page">
      <span
        class="change-page__btn"
        :class="{ active: showheader }"
        @click="showFirstHeader"
      ></span>
      <span
        class="change-page__btn"
        :class="{ active: !showheader }"
        @click="showSecoundHeader"
      ></span>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      showheader: true,
      timeAnimate: 7000,
      pageAnimate: null,
    };
  },
  mounted() {
    this.runAnimate();
  },
  methods: {
    showFirstHeader() {
      clearTimeout(this.pageAnimate);
      this.pageAnimate = setTimeout(() => {
        this.showheader = !this.showheader;
        this.runAnimate();
      }, this.timeAnimate);

      this.showheader = true;
    },
    showSecoundHeader() {
      clearTimeout(this.pageAnimate);
      this.pageAnimate = setTimeout(() => {
        this.showheader = !this.showheader;
        this.runAnimate();
      }, this.timeAnimate);
      
      this.showheader = false;
    },
    runAnimate() {
      this.pageAnimate = setTimeout(() => {
        this.showheader = !this.showheader;
        this.runAnimate();
      }, this.timeAnimate);
    },
  },
};
</script>

<style></style>
